// extracted by mini-css-extract-plugin
export default {"container":"tag_container__kE-Pt","tag":"tag_tag__vmEnd","item":"tag_item__kayrT","itemDetail":"tag_itemDetail__-+EZm","image":"tag_image__gXD9K","name":"tag_name__j7w9b"};